function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  className: styles["icon"] || "icon",
  viewBox: "0 0 1024 1024",
  xmlns: "http://www.w3.org/2000/svg",
  width: "200",
  height: "200"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M560 320V48a48 48 0 00-96 0v272H326.656a16 16 0 00-11.328 27.328l185.344 185.344a16 16 0 0022.656 0l185.344-185.344A16 16 0 00697.344 320H560z",
  fill: "#24292E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M96 176a16 16 0 0116-16h192a48 48 0 000-96H112A112 112 0 000 176v480c0 61.824 50.176 112 112 112h238.528c-6.4 66.624-33.28 119.808-82.688 176.448A48 48 0 00304 1024h416a48 48 0 0036.16-79.552c-49.408-56.64-76.352-109.824-82.688-176.448H912a112 112 0 00112-112V176A112 112 0 00912 64H720a48 48 0 000 96h192a16 16 0 0116 16v480a16 16 0 01-16 16H112a16 16 0 01-16-16V176zm481.152 592a366.08 366.08 0 0048.96 160H397.888a366.08 366.08 0 0048.96-160h130.304z",
  fill: "#24292E"
}));